import * as React from 'react';
import { FC } from 'react';

import { FormControl } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { useIdCounter } from 'hooks/use-id-counter';

import { InputMessage } from '../input-message';

import { IFieldSetProps } from './types';

/**
 * Groups several form fields and their labels together
 */
const FieldSet: FC<React.PropsWithChildren<IFieldSetProps>> = ({
  disabled,
  label,
  children,
  errorMessage,
  hintMessage,
  messageId: messageIdProp,
  testID,
  ...props
}) => {
  const defaultMessageId = useIdCounter('fieldset-message');
  const messageId = messageIdProp || defaultMessageId;

  return (
    <Box accessibilityLabel="group" {...props} style={[styles.container, props.style]}>
      {label && <FormControl.Label isDisabled={disabled}>{label}</FormControl.Label>}
      {children}
      <InputMessage disabled={disabled} id={messageId} hasError={!!errorMessage} testID={testID}>
        {!errorMessage && hintMessage}
      </InputMessage>
    </Box>
  );
};

export default FieldSet;

const styles = StyleSheet.create({
  container: {
    margin: 0,
    padding: 0,
    width: '100%',
  },
});
